import { NgOptimizedImage } from '@angular/common';
import { Component, HostBinding } from '@angular/core';

import { TrustPipe } from '@frontend/sports/common/core/utils/dom';
import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { MarketingViewModel } from '@frontend/sports/types/components/marketing';
import { isEmpty } from 'lodash-es';

import { WidgetComponent } from '../widget/core/widget-registry.service';

@Component({
    selector: 'ms-static-teaser-widget',
    templateUrl: './static-teaser-widget.component.html',
    styleUrls: ['./static-teaser-widget.component.scss'],
    imports: [NgOptimizedImage, TrustPipe],
})
export class StaticTeaserWidgetComponent extends WidgetComponent<MarketingViewModel> {
    @HostBinding('class') className = 'static-teaser-widget';

    trackingSource = 'Static Teaser';

    teaser: MarketingViewModel;
    image?: string;

    constructor(private trackingService: TrackingService) {
        super();
    }

    protected override onData(data: MarketingViewModel): void {
        this.teaser = data;
        if (this.teaser?.imageUrl) {
            this.image = `${this.teaser.imageUrl}?p=width540`;
        }

        this.hasData = !isEmpty(data);
        this.setWidgetLoaded();
    }

    trackBannerClicked(): void {
        this.trackingService.track(trackingConstants.EVENT_CLICKS, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'Teaser Banners',
            [trackingConstants.COMPONENT_LABEL_EVENT]: this.trackingSource,
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'Click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: 'teaser',
            [trackingConstants.COMPONENT_URL_CLICKED]: this.teaser.href,
        });
    }
}
